import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/index.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      redirect: '/HomePage',
      children: [
        {
          path: '/HomePage',
          name: 'HomePage',
          zhName: '首页',
          component: resolve => require(['@/views/HomePage/index.vue'], resolve),
        },
        {
          path: '/Solution',
          name: 'Solution',
          zhName: '智能解决方案',
          component: resolve => require(['@/views/Solution/index.vue'], resolve),
        },
        {
          path: '/Products',
          name: 'Products',
          zhName: '产品中心',
          component: resolve => require(['@/views/Products/index.vue'], resolve),
        },
        {
          path: '/Case',
          name: 'Case',
          zhName: '客户案例',
          component: resolve => require(['@/views/Case/index.vue'], resolve),
        },
        // 案例详情路由
        {
          path: '/Case/Details/1',
          name: 'CaseDetail1',
          component: resolve => require(['@/views/Case/Details/case1.vue'], resolve),
        },
        {
          path: '/Case/Details/2',
          name: 'CaseDetail2',
          component: resolve => require(['@/views/Case/Details/case2.vue'], resolve),
        },
        {
          path: '/Case/Details/3',
          name: 'CaseDetail3',
          component: resolve => require(['@/views/Case/Details/case3.vue'], resolve),
        },
        // {
        //   path: '/News',
        //   name: 'News',
        //   zhName:'资讯动态',
        //   component: resolve => require(['@/views/News/index.vue'], resolve),
        // },
        {
          path: '/AboutUs',
          name: 'AboutUs',
          zhName: '关于我们',
          component: resolve => require(['@/views/AboutUs/index.vue'], resolve),
        },
        {
          path: '/ContactUs',
          name: 'ContactUs',
          zhName: '联系我们',
          component: resolve => require(['@/views/ContactUs/index.vue'], resolve),
        }
      ]
    },
    // {
    //   path: '/NewDetails',
    //   name: 'NewDetails',
    //   zhName: "资讯动态-详情",
    //   component: resolve => require(['../views/News/NewDetails/NewDetails.vue'], resolve),
    // },
    // {
    //   path: '/NewInt',
    //   name: 'NewInt',
    //   zhName: "资讯动态-详情",
    //   component: resolve => require(['../views/News/NewDetails/NewInt.vue'], resolve),
    // },
  ]
})

// 全局后置守卫：每次路由跳转后滚动到页面顶部
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js